// extracted by extract-css-chunks-webpack-plugin
module.exports = {"locked-fund-name":"reference-fields__locked-fund-name___1Lpkk","lockedFundName":"reference-fields__locked-fund-name___1Lpkk"};
    if(module.hot) {
      // 1747191973354
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  